import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { getInlineLoader } from "../Helpers";
import {
	STR_ALL,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_LEARN,
	STR_LEARN_2,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_SEARCH_HERE,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdContactPage, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSearch, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import OneArticle from '../ones/OneArticle';

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	const [filter, setFilter] = useState('');
  const [category, setCategory] = useState('');

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all(
      [
        appContext.getArticlesFeed(),
        appContext.getCurrentUserData(),
      ]
    )
		setReady(true);
	}



	useEffect(() => {
		init();
	}, [])



	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">
						<div className="col-md-12">
							<h6
								className="mSectionTitle"
							>
								{STR_LEARN_2[appContext.language]}
							</h6>
						</div>

						<div 
              className="col-md-12"
              
            >
              <div 
                className="input-group bg-surface"
                style={{
                  borderRadius: "0px",
                  overflow: "hidden"
                }}
              >
                <span
                  className="input-group-text font-semi-bold bg-surface"
                  style={{
                    fontSize: "22px",
                    border: "none"
                  }}
                >
                  <MdSearch/>
                </span>
                <input
                  className="form-control mSearchField"
                  onChange={(e) => setFilter(e.target.value)}
                  value={filter}
                  placeholder={STR_SEARCH_HERE[appContext.language]}
                  type="text"
                  style={{
                    fontSize: "16px",
                  }}
                />
              </div>
      
              <div 
                className="d-flex overflow-auto mt-3 mNoScrollBar"
                style={{
                  paddingBottom: "20px"
                }}
              >
                <button 
                  className={(!category) ? "btn btn-rounded btn-primary me-2" : "btn btn-rounded btn-outline-secondary me-2"}
                  style={{
                    height: "40px",
                    width: "auto",
                    whiteSpace: "nowrap", // Prevents text wrapping
                    fontSize: "14px",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                  }}
                  onClick={() => {
                    setCategory('');
                  }}
                >
                  {STR_ALL[appContext.language]}
                </button>
      
                {JSON.parse(appContext.systemParams.articleCategories).map((item, i) => (
                  <button 
                    key={i} 
                    className={(category === item.id) ? "btn btn-rounded btn-primary me-2" : "btn btn-rounded btn-outline-secondary me-2"}
                    style={{
                      height: "40px",
                      width: "auto",
                      whiteSpace: "nowrap", // Prevents text wrapping
                      fontSize: "14px",
                    }}
                    onClick={() => {
                      setCategory(item.id);
                    }}
                  >
                    {item.description[appContext.language]}
                  </button>
                ))}

                
              </div>
              <hr/>
            </div>
            

            {
              (appContext.articlesFeed && appContext.articlesFeed.length > 0) ?
              appContext.articlesFeed.map((item, i) => {
      
                if(category) {
                  if(JSON.parse(item.categories).indexOf(category) > -1) {
                    if(filter && filter.trim().length > 0) {
                      if(String(item.title).toLowerCase().indexOf(String(filter).toLowerCase()) > -1) {
                        return (
                          <div className="col-md-4 col-md-12" key={i}>
                            <OneArticle data={item}/>
                            <hr/>
                          </div>
                        );
                      } else {
                        return null;
                      }
                    } else {
                      return (
                        <div className="col-md-4 col-md-12" key={i}>
                          <OneArticle data={item}/>
                          <hr/>
                        </div>
                      );
                    }
                  } else {
                    return null;
                  }
                } else {
                  if(filter && filter.trim().length > 0) {
                    if(String(item.title).toLowerCase().indexOf(String(filter).toLowerCase()) > -1) {
                      return (
                        <div className="col-md-4 col-md-12" key={i}>
                          <OneArticle data={item}/>
                          <hr/>
                        </div>
                      );
                    } else {
                      return null;
                    }
                  } else {
                    return (
                      <div className="col-md-4 col-md-12" key={i}>
                        <OneArticle data={item}/>
                        <hr/>
                      </div>
                    );
                  }
                }
                
              })
              :
              <div className="col-md-12">
                <h6
                  style={{
                    fontSize: "12px"
                  }}
                >
                  {STR_NO_RECORD[appContext.language]}
                </h6>
              </div>
            }

					</div>

					

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}